import { fetchNoToken } from "../helpers/fetch";
import { appointmentActions } from "../store/appointmentSlice";
import { showSimpleMessage } from "./ui";

export const setIsModalOpen = (status) => {
  return async (dispatch) => {
    dispatch(appointmentActions.setIsModalOpen(status));
  };
};

export const requestAppointment = (
  property_id,
  selectedDate,
  selectedTime,
  selectedName,
  selectedEmail,
  selectedPhone
) => {
  return async (dispatch) => {
    try {
      const data = {
        property_id: property_id,
        name: selectedName,
        email: selectedEmail,
        cellphone: selectedPhone,
        appointment_date: selectedDate,
        appointment_hour: selectedTime,
      };
      const response = await fetchNoToken("request_appointment", data, "POST");
      const body = await response.json();
      const errors = body.errors;
      if (errors) {
        dispatch(showSimpleMessage("Error", errors[0]));
        console.log("Error:", body.errors);
      } else {
        dispatch(showSimpleMessage("Cita creada", "Cita creada exitosamente"));
        dispatch(appointmentActions.clearAppointmentData());
        dispatch(appointmentActions.setIsModalOpen(false));
      }
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const startChangetDate = (newDate) => {
  return async (dispatch) => {
    dispatch(appointmentActions.setDate(newDate.getTime()));
    try {
      const data = { date: newDate.getTime() };
      const response = await fetchNoToken(
        "available_appointment",
        data,
        "POST"
      );
      const body = await response.json();
      if (body.errors) {
        dispatch(appointmentActions.setDate(null));
        dispatch(appointmentActions.setAvailableTimeSlots({}));
      } else {
        dispatch(appointmentActions.setAvailableTimeSlots(body));
      }
    } catch (error) {
      dispatch(appointmentActions.setDate(null));
    }
  };
};

export const setTime = (value) => {
  return async (dispatch) => {
    dispatch(appointmentActions.setTime(value));
  };
};

export const setName = (value) => {
  return async (dispatch) => {
    dispatch(appointmentActions.setName(value));
  };
};

export const setPhone = (value) => {
  return async (dispatch) => {
    dispatch(appointmentActions.setPhone(value));
  };
};

export const setEmail = (value) => {
  return async (dispatch) => {
    dispatch(appointmentActions.setEmail(value));
  };
};
